<template>
    <div class="toggle-tab" ref="toggleTab" tabindex="0" @click="toggle"  @pointerenter="isHovered= true" @pointerleave="isHovered=false" @touchstart="isHovered= false">
        <rotate-chevron :direction="chevronDirection" :class="{'bouncy-arrow': isHovered}"/>
        <img src="/images/icon-flyer.svg" class="flyer-book" width="22px" height="22px"  alt=""/>
        <span class="caption" data-tour-item="flyer-selector">{{ tabCaption }}</span>
        <PoweredByTC v-if="isPoweredByTC" />
    </div>

</template>
<script>
import featureMixin from "@/mixins/featureMixin";
import RotateChevron from "@/components/buttons/RotateChevron.vue";
import PoweredByTC from "@/features/flyer-selector/inline/PoweredByTC.vue"
import Lytics from "@/classes/Lytics";
import { mapActions, mapGetters } from "vuex";

export default {
name: "InlineFlyerSelector",
components: { RotateChevron, PoweredByTC},
mixins:[featureMixin],
props: {
    autofocus: {
        type: Boolean,
        default: false
    }
},
data(){
return {
    featurePath: 'flyerSelector',
    isHovered: false,
}
},
mounted(){
    if (this.autofocus) {
        // delay so screen readers finish announcing the toggle button's "drawer opened/closed" label before focus moves
        this.$nextTick(() => setTimeout(() => this.$refs.toggleTab.focus(), 2000));
    }
},
computed:{
      ...mapGetters("inlineDrawers", ["isFilterOpen"]),

isPoweredByTC() {
return this.config?.poweredByTC
},
chevronDirection(){
    const cd = {
        'left': this.showList? 'left': 'right',
        'right': this.showList? 'right': 'left',
        'top': this.showList? 'up': 'down',
        'bottom': this.showList? 'down': 'up'
    }
    return cd[this.config.position];
},
tabCaption(){
    return this.showList? this.content?.flyerSelector?.hideFlyers: this.content?.flyerSelector?.showFlyers
},
showList(){
    return !!this._config.isVisible;
},
},
methods:{
  ...mapActions("inlineDrawers", ["openFlyer", "closeFilter"]),

		toggle() {
            const nextVisible = !this._config.isVisible;
            if (nextVisible && this.isFilterOpen) {
            this.closeFilter();
            }
            this._config.isVisible = nextVisible;
            Lytics.TriggerDrawerToggle(nextVisible);
            if (!nextVisible) {
                this.$nextTick(() => this.$refs.toggleTab.focus());
            }
          }
}


}
</script>

<style lang="scss">
.inline-flyer-selector {
--drawer-open-width: 10em;

display: flex;
color: #fff;
.toggle-tab {
    position: relative;
    background-color: #333333;
    display: flex;
    writing-mode: vertical-rl;
    //column-gap: 0.5em;
    cursor: pointer;
    align-items: center;
    .caption {
        rotate: 180deg;
        font-size: 0.8em;
    }
    .rotate-chevron {
        width: 0.6em;
    }
    
}


&.left{
    .toggle-tab {
        padding: 1em 0;
        width: 38px;
        border-radius: 0 4px 4px 0;
        > * {
        margin-bottom: 0.5em;
    }
    }
}
&.top{
    flex-direction: column;
    .toggle-tab {
        writing-mode: initial;
        justify-content: center;
        padding: 0.5em;
        border-radius: 0 0 4px 4px;
        .caption {
            rotate: 0deg;
        }
        > * {
        margin-right: 0.5em;
       }  
    }
}
}

</style>
